<template>
  <div>
    <Head title="Sms Templates" />
    <h1 class="mb-8 text-3xl font-bold">Text Templates</h1>
    <div class="flex items-center justify-between mb-6">
      <div class="text-right">
        <div v-show="!toggle" class="cursor-pointer duration-300 noteDiv text-indigo-500" @click="toggle = !toggle">
          <i class="fas fa-plus text-3xl" />
        </div>
        <div v-show="toggle" class="cursor-pointer duration-300 noteDiv text-indigo-500" @click="toggle = !toggle">
          <i class="fas fa-minus text-3xl" />
        </div>
      </div>
    </div>
    <div v-show="toggle">
    <div class="max-w-screen-xl m-auto">
      <form id="templateForm" name="templateForm" @submit.prevent="addTemplate">
        <div class="flex flex-wrap mb-4 mr-6 p-8 bg-white rounded-lg shadow overflow-hidden">
          <h1 class="pb-4 pr-6 w-full text-xl text-center font-bold">New Template: {{ templateForm.title }}</h1>
          <text-input v-model="templateForm.title" :error="templateForm.errors.title" class="pb-4 pr-6 w-full font-bold" label="Title" />
          <label class="form-label font-bold">Message:</label>
          <input id="textInput" v-model="templateForm.message" class="form-textarea w-full pr-6 pb-4" :class="{ error: templateForm.errors.message }" />
          <div v-if="templateForm.errors.message" class="form-error font-bold">{{ templateForm.errors.message }}</div>
          <div class="tflex justify-center mx-auto text-center items-center w-full mt-4 pb-2 text-m">
            <span class="cursor-pointer" @click="insertField('😊')">😊</span>
            <span class="cursor-pointer" @click="insertField('😆')">😆</span>
            <span class="cursor-pointer" @click="insertField('🤣')">🤣</span>
            <span class="cursor-pointer" @click="insertField('😜')">😜</span>
            <span class="cursor-pointer" @click="insertField('🤔')">🤔</span>
            <span class="cursor-pointer" @click="insertField('👍')">👍</span>
            <span class="cursor-pointer" @click="insertField('🙏')">🙏</span>
            <span class="cursor-pointer" @click="insertField('🥰')">🥰</span>
            <span class="cursor-pointer" @click="insertField('❤️')">❤️</span>
            <span class="cursor-pointer" @click="insertField('🎉')">🎉</span>
            <span class="cursor-pointer" @click="insertField('🔥')">🔥</span>
            <span class="cursor-pointer" @click="insertField('😍')">😍</span>
            <span class="cursor-pointer" @click="insertField('😂')">😂</span>
            <span class="cursor-pointer" @click="insertField('🙌')">🙌</span>
            <span class="cursor-pointer" @click="insertField('🤗')">🤗</span>
            <span class="cursor-pointer" @click="insertField('😎')">😎</span>
          </div>
          <div class="text-m w-full text-left">
            <span class="tag-input__tag text-sm cursor-pointer">Insert Lead Fields</span>
            <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%first%')">first name</span>
            <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%fullName%')">full name</span>
            <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%phone%')">phone</span>
            <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%email%')">email</span>
            <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%fullNameCoborrower%')">co-full name</span>
            <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%phoneCoborrower%')">co-phone</span>
            <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%emailCoborrower%')">co-email</span>
          </div>
          <div class="text-m mt-2 pb-2 w-full text-left">
            <span class="tag-input__tag text-sm cursor-pointer">Insert User Fields</span>
            <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%user_first_name%')">first name</span>
            <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%user_last_name%')">last name</span>
            <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%user_phone%')">phone</span>
            <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%user_email%')">email</span>
            <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%user_application_link%')">app link</span>
            <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%user_appointment_link%')">appointment</span>
          </div>
          <div class="pb-4 w-full">
            <attachment-uploader :initial-attachment-url="templateForm.attachment" message-type="sms" @update:attachmentUrl="updateAttachmentUrl" @update:attachmentName="updateAttachmentName"/>
           </div>
          <loading-button :loading="templateForm.processing" class="cursor-pointer btn-indigo ml-auto mb-4">Add Template</loading-button>
        </div>
      </form>
      </div>
    </div>
    <h2 class="mb-8 text-xl font-bold">Template Library</h2>
    <div v-for="template in smsTemplates" :key="template.id">
      <SingleSmsTemplate :template="template" :error="templateForm.errors" />
    </div>
  </div>
</template>

<script>
import { Head, router } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import SingleSmsTemplate from '@/Shared/SingleSmsTemplate'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import AttachmentUploader from '@/Shared/AttachmentUploader'

export default {
  components: {
    Head,
    SingleSmsTemplate,
    TextInput,
    LoadingButton,
    AttachmentUploader,
  },
  layout: Layout,
  props: {
    smsTemplates: Object,
  },
  data() {
    return {
      templateForm: router.form({
        title: '',
        message: '',
        attachment: '',
        attachmentName: '',
      }),
      attachmentError: '',
      toggle: false,
    }
  },
  methods: {
    insertField(token) {
      // Get the text area element
      let textArea = document.getElementById('textInput')

      // Save the current cursor position
      let cursorPos = textArea.selectionStart

      // Insert the emoji at the cursor position
      textArea.value = textArea.value.substring(0, cursorPos) + token + textArea.value.substring(cursorPos)

      // Update the cursor position to be after the inserted emoji
      textArea.selectionEnd = cursorPos + token.length

      textArea.focus()
    },
    isImage(url) {
      // Regular expression to match common image extensions
      const imageExtensions = /\.(jpg|jpeg|png|gif)$/i;
      return imageExtensions.test(url);
    },
    removeAttachment() {
      this.templateForm.attachment=null
      this.templateForm.attachmentName=null
    },
    updateAttachmentUrl(url) {
      this.templateForm.attachment = url
    },
    updateAttachmentName(name) {
      this.templateForm.attachmentName = name
    },
    addTemplate() {
      this.templateForm.post('/smsTemplates', {
        onSuccess: () => {
          this.templateForm.reset('title')
          this.templateForm.reset('message')
          this.templateForm.attachment=null
        },
      })
    },
  },
}
</script>
<style>
.tag-input__text {
  border: none;
  outline: none;
  line-height: 50px;
  background: none;
}
.tag-input__tag {
  height: 30px;
  float: left;
  margin-right: 10px;
  /* background-color: #eee; */
  margin-top: 10px;
  line-height: 30px;
  padding: 0 10px;
  border-radius: 5px;
}
.tag-input__tag > span {
  cursor: pointer;
  opacity: 0.75;
}
</style>
